import React from "react";

const DeleteAskModal = ({ closeModal, onDelete }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-lg">
      <div className="bg-white p-6 rounded-lg shadow-lg text-[#000] ">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold">Устгах</h2>
          <h2 className="cursor-pointer text-xl" onClick={closeModal}>
            X
          </h2>
        </div>
        <p className="mb-4">Та устгахдаа итгэлтэй байна уу?</p>
        <div className="flex justify-end gap-4">
          <button
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            onClick={onDelete}
          >
            Устгах
          </button>
          <button
            className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
            onClick={closeModal}
          >
            Цуцлах
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAskModal;
